import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex px-[9px] md:px-6 justify-between items-center w-full h-16 bg-brown xl:hidden border-t border-[#4C3F3A]" }
const _hoisted_2 = { class: "flex gap-2" }

import EmailIcon from "@/components/icons/EmailIcon.vue";
import InstagramIcon from "@/components/icons/InstagramIcon.vue";
import { computed, onMounted, ref } from "vue";
import PhoneModal from "@/components/modals/PhoneModal.vue";
import LoginButton from "@/components/buttons/LoginButton.vue";
import router from "@/router";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useSocialsStore } from "@/stores/socialsStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'PageFooter',
  setup(__props) {

const isPhoneModalVisible = ref(false);

const socialStore = useSocialsStore();

const emailLink = computed(() => socialStore.socialLinks.email);
const instagramLink = computed(() => socialStore.socialLinks.instagram);

onMounted(async () => {
  await socialStore.loadSocials();
});

function openLoginPage() {
  router.push({ name: ROUTE_NAMES.USER });
}

function openSocialLink(url: string) {
  window.open(url, "_blank", "noopener,noreferrer");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (emailLink.value)
        ? (_openBlock(), _createBlock(EmailIcon, {
            key: 0,
            class: "w-[46px] h-[46px]",
            type: "gold"
          }))
        : _createCommentVNode("", true),
      (instagramLink.value)
        ? (_openBlock(), _createBlock(InstagramIcon, {
            key: 1,
            class: "w-[46px] h-[46px]",
            type: "gold",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openSocialLink(instagramLink.value)))
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(LoginButton, {
      class: "!h-[48px]",
      onClick: openLoginPage
    }),
    (isPhoneModalVisible.value)
      ? (_openBlock(), _createBlock(PhoneModal, {
          key: 0,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (isPhoneModalVisible.value = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})